<template>
  <div v-if="spotlight.businessName !== 'Testipaikka'">
    <h1 class="title">Nostossa tänään</h1>
    <p class="caption">
      Tähän nostetaan enemmän tai vähemmän satunnaisesti eri yrityksitä.
    </p>
    <v-skeleton-loader v-if="loading" type="card" />
    <v-card v-else class="my-2" outlined>
      <v-list-item three-line>
        <v-list-item-content>
          <v-list-item-title class="headline mb-1">{{
            spotlight.businessName
          }}</v-list-item-title>
          <v-list-item-subtitle>{{ spotlight.infoText }}</v-list-item-subtitle>
        </v-list-item-content>

        <v-list-item-avatar tile size="80">
          <v-img :src="logoUrl"></v-img>
        </v-list-item-avatar>
      </v-list-item>

      <v-card-actions>
        <v-btn text color="green" :to="`/yritys/${spotlight.id}`"
          >Tutustu</v-btn
        >
      </v-card-actions>
      <p
        class="px-4 pb-4 overline font-italic font-weight-light"
        style="font-size: 5px; line-height: 100%; letter-spacing: 0 !important;"
      >
        Ylläolevat tekijänoikeuksin suojatut merkit omistaa niiden omistaja.
        Tietojen oikeudellisuudesta vastaa {{ spotlight.businessName }}.
      </p>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'Spotlight',
  mounted() {
    fetch('https://hallinta.kotona.kiuruvesi.net/fontend/spotlight')
      .then(res => res.json())
      .then(res => {
        return (this.spotlight = { ...res })
      })
      .catch(
        e =>
          void alert(
            'Järjestelmävirhe! Sivua ei voi näyttää :( (loadingCa) ' + e
          )
      )
      .finally(() => {
        this.loading = false
      })
  },
  data: () => ({
    loading: true,
    spotlight: {
      businessName: 'Testipaikka',
      infoText:
        'Palasin juuri uudesta koulustani, sain tänään tietää, että minun ei tarvitse osallistua ollenkaan ruotsin kielen tunneille, sillä kielitaitoni on niin vahva! Jee, tosi hienoa, saan skipattua kuulemma koko kurssin! Asuin vuonna -98 Ruotsissa ja opiskelin ruotsin kieltä Uppsalan yliopistossa, joten minun ei tarvitse käydä perusasioita',
      filestackHandle: 'ef7GrvYSdGRfEOAR3a0u',
      category: 'food'
    }
  }),
  computed: {
    logoUrl() {
      return `https://cdn.filestackcontent.com/${this.spotlight.filestackHandle}`
    }
  }
}
</script>
